/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl,
  HelpBlock,
  Form,
  InputGroup,
} from "react-bootstrap";

import Card from "components/Card/Card.jsx";

import Checkbox from "components/CustomCheckbox/CustomCheckbox.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import Radio from "components/CustomRadio/CustomRadio.jsx";
import SweetAlert from "react-bootstrap-sweetalert";
import NotificationSystem from "react-notification-system";
import { AddMedicationcategory } from "../../../Listfunction";
import { style } from "../../../variables/Variables";

class addcategoey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: "1",
      radioVariant: "1",
      wt_commision: "",
      category_order: "",
      wt_commisionError: null,
      medicationcategoryname: "",
      medicationcategorynameError: null,
      alert: null,
      errormessage: "",
      _notificationSystem: null,
      cardHidden: true,
      is_featured: "2",
      errormessages: [],
      attachments: [],
      attached_image: [],

    };
    this.handleChange = this.handleChange.bind(this);
    this.onChange = this.onChange.bind(this);
    this.handlesubmit = this.handlesubmit.bind(this);
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }
  upload() {
    document.getElementById("category_image").click();
  }
  handleSuccess(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "success";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Medication Category</b> - Added Successfully .
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleClick(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>something went wrong</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  componentDidMount() {
    this.setState({ _notificationSystem: this.refs.notificationSystem });
    setTimeout(
      function () {
        this.setState({ cardHidden: false });
      }.bind(this),
      700
    );
  }
  handleNetworkError(position) {
    var color = Math.floor(Math.random() * 4 + 1);
    var level;
    switch (color) {
      case 1:
        level = "success";
        break;
      case 2:
        level = "warning";
        break;
      case 3:
        level = "error";
        break;
      case 4:
        level = "info";
        break;
      default:
        break;
    }
    level = "error";
    this.state._notificationSystem.addNotification({
      title: <span data-notify="icon" className="pe-7s-gift"></span>,
      message: (
        <div>
          <b>Network Error</b>.
        </div>
      ),
      level: level,
      position: position,
      autoDismiss: 15,
    });
  }
  handleFileChange(event) {
    let data = [];
    for (let i = 0; i < event.target.files.length; i++) {
      data.push(event.target.files[i]);
      // console.log(data);
    }
    this.setState({ attachments: data });

// console.log(this.state.attachments);
  }

  handlesubmit = (e) => {
    let error = false;
    // console.log(this.state.medicationcategoryname.length);
    this.setState({ errormessages: [] });
    if (this.state.medicationcategoryname.length == 0) {
      error = true;
      this.setState({
        medicationcategorynameError: (
          <small className="text-danger">
            Medication Category Name is required.
          </small>
        ),
      });
    } else {
      this.setState({ medicationcategorynameError: null });
    }

    {
      /* 
    if (this.state.wt_commision.length == 0) {
      error = true;
      this.setState({
        wt_commisionError: (
          <small className="text-danger">Wt-commision is required..</small>
        ),
      });
    } else {
      this.setState({ wt_commisionError: null });
    }
    */
    }

    if (!error) {
      var token = JSON.parse(localStorage.getItem("user"));
// console.log( this.state.attachments);
      const obj = token.token;
      var is_featured = "";
      if (this.state.is_featured == "1") {
        is_featured = "1";
      } else if (this.state.is_featured == "2") {
        is_featured = "0";
      }
      let atchFiles = this.state.attachments;

      // const attaced_image = [];
      // for (let i = 0; i < this.state.attachments.length; i++) {
      //   attaced_image.append("files[]", atchFiles[i]);
      // }
      // console.log(attaced_image);
      // AddMedicationcategory(
      //   this.state.medicationcategoryname,
      //   this.state.wt_commision,
      //   attaced_image,
      //   is_featured,
      //   obj
      // )
      let fdata = new FormData();
      for (let i = 0; i < atchFiles.length; i++) {
        // console.log(atchFiles);
        // fdata.append("files[]", atchFiles);
        fdata.append("attached_image[]", atchFiles[i]);
      }
   
      //   attaced_image,
      fdata.append("category_name", this.state.medicationcategoryname);
      fdata.append("wt_commision", this.state.wt_commision);
      fdata.append("category_order", this.state.category_order);
      // fdata.append("attached_image", this.state.attachments);
      fdata.append("is_featured", this.state.is_featured);

      AddMedicationcategory(obj, fdata)
        .then((res) => {
          if (res.data.success === false) {
            const message = res.data.data;

            if (res.data.data.length != 0) {
              var ermessage = [];
              for (var key of Object.keys(res.data.data)) {
                var data = res.data.data[key];
                ermessage.push(data);
              }
              this.setState({ errormessages: ermessage });
              this.setState({
                medicationcategorynameError: (
                  <small className="text-danger">{message.category_name}</small>
                ),
              });
            } else {
              this.handleClick("bl");
            }
          } else if (res.data.success === true) {
            this.handleSuccess("bl");
            this.setState({
              medicationcategoryname: "",
              wt_commision: "",
              category_order: "",
              attachments: "",
            });
            // this.props.history.push('/admin/medication-category');
          }
        })
        .catch((error) => {
          this.handleNetworkError("bl");
          console.log(error, "== error");
        });
    }
  };

  handleChange = (event) => {
    const target = event.target;
    this.setState({
      [target.name]: target.value,
    });
  };
  onChange = (event) => {
    const target = event.target;
    const value = target.type === "select" ? target.selected : target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };
  removeFileItem = (num) => {
    var dataList = this.state.attachments;
    dataList.splice(num, 1);
    this.setState({
      attachments: dataList,
    });
  };
  render() {
    const errormessages = this.state.errormessages;
    return (
      <div className="main-content">
        <Grid fluid>
          <NotificationSystem ref="notificationSystem" style={style} />

          <Row>
            <Col md={12}>
              <Card
                content={
                  <form>
                    {errormessages.length != 0 && (
                      <div className=" alert alert-danger">
                        {errormessages.map((data) => (
                          <React.Fragment>
                            <li>{data}</li>
                          </React.Fragment>
                        ))}
                      </div>
                    )}

                    <FormGroup>
                      <ControlLabel> Category Name</ControlLabel>
                      <FormControl
                        name="medicationcategoryname"
                        value={this.state.medicationcategoryname || ""}
                        onChange={(event) => {
                          this.setState({
                            medicationcategoryname: event.target.value,
                          });
                          event.target.value === ""
                            ? this.setState({
                                medicationcategorynameError: (
                                  <small className="text-danger">
                                    Medication Category Name is required.
                                  </small>
                                ),
                              })
                            : this.setState({
                                medicationcategorynameError: null,
                              });
                        }}
                        placeholder="Enter Medication Categoryname"
                        type="text"
                      />
                      {this.state.medicationcategorynameError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>WT_Commition</ControlLabel>
                      <FormControl
                        name="wt_commision"
                        value={this.state.wt_commision || ""}
                        onChange={(event) => {
                          this.setState({ wt_commision: event.target.value });
                        }}
                        placeholder="Enter WT_Commision"
                        type="number"
                      />
                      {this.state.wt_commisionError}
                    </FormGroup>
                    <FormGroup>
                      <ControlLabel>Category Order</ControlLabel>
                      <FormControl
                        name="category_order"
                        value={this.state.category_order || ""}
                        onChange={(event) => {
                          this.setState({ category_order: event.target.value });
                        }}
                        placeholder="Enter Category Number"
                        type="number"
                      />
                      {this.state.wt_commisionError}
                    </FormGroup>

                    <FormGroup className="">
                      <ControlLabel>Is Featured ? &nbsp;</ControlLabel>
                      <Radio
                        number="7"
                        option="1"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "1"}
                        label="Yes"
                      />
                      <Radio
                        number="8"
                        option="2"
                        name="is_featured"
                        onChange={this.onChange}
                        checked={this.state.is_featured === "2"}
                        label="No"
                      />
                    </FormGroup>

                    <FormGroup>
                      <ControlLabel>Image </ControlLabel>
                      <input
                        style={{ display: "none" }}
                        id="category_image"
                        type="file"
                        className="form-control"
                        name="category_image"
                        multiple
                        onChange={this.handleFileChange.bind(this)}
                      />
                      <Button
                        onClick={this.upload}
                        style={{ color: "#2B3A41", display: "block" }}
                      >
                        {" "}
                        <i
                          className={
                            this.state.attachments == ""
                              ? "fa fa-plus"
                              : "fa fa-pencil fa-fw"
                          }
                        ></i>{" "}
                        {this.state.attachments == ""
                          ? "Choose File"
                          : "Change File"}
                      </Button>
                    </FormGroup>
                    <Col xs={12} className="attecth_filelist">
                    {this.state.attachments.length > 0 &&
                      this.state.attachments.map((attch, idx) => (
                        <div className="attecth_filelist_row">
                          <h6 key={idx}>
                            <a
                              href={URL.createObjectURL(attch)}
                              target="_blank"
                            >
                              {attch.name}
                            </a>
                          </h6>
                          <p onClick={() => this.removeFileItem(idx)}>x</p>
                        </div>
                      ))}
                  </Col>

                    <Button onClick={this.handlesubmit} class="btn-color" fill>
                      Submit
                    </Button>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default addcategoey;
